module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Branson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Branson is the author of the eye-opening "), _c('I', [_vm._v("101 Amazing Uses")]), _vm._v(" series, a collection of guides for people wanting to live without harmful products in their home. Susan is a toxicologist and holistic nutritional consultant who currently lives in Parkland, Florida, with her husband and two children.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/plZcIS/tc-custom/9781945547478.jpg?1704717815157",
      "alt": "This image is the cover for the book 101 Amazing Uses for Ginger, A 101 Amazing Uses Book"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Amazing Uses for Ginger, A 101 Amazing Uses Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Discover the surprising uses and benefits of ginger—from fighting cancer cells to taming spit ends—in this holistic nutrition guide.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Everyone knows the rich, distinctive flavor of ginger. But did you know this knobby root can be a source of healing, nutrients, and rejuvenating beauty? From managing nausea to preventing hypothermia, ginger’s uses are incredibly diverse. In 101 Amazing Uses for Ginger, holistic nutrition consultant Susan Branson shares the wide array of reasons everyone should have some fresh ginger on hand."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Branson’s "), _c('i', [_vm._v("101 Amazing Uses")]), _vm._v(" series reveals the practical yet little-known uses for common natural products, including apple cider vinegar, aloe vera, coconut oil and more. Each book is filled with easy-to-read, bite-sized benefits for everything from health to beauty to household cleaning.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Familius LLC\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0